<ng-container [ngSwitch]="status">
  <ng-container *ngSwitchCase="'OK'">
    <p [testId]="testId">{{ message }}</p>
  </ng-container>
  <ng-container *ngSwitchCase="'WARN'">
    <p class="text-amber-600" [testId]="testId">{{ message }}</p>
  </ng-container>
  <ng-container *ngSwitchCase="'ERROR'">
    <p class="text-red-500" [testId]="testId">{{ message }}</p>
  </ng-container>
</ng-container>
